import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: "Headband",
    description: "",
  },
  {
    _id: uuid(),
    categoryName: "Shuriken",
    description: "",
  },
  {
    _id: uuid(),
    categoryName: "Kimono",
    description: "",
  },
  {
    _id: uuid(),
    categoryName: "Clothes",
    description: "",
  },
  {
    _id: uuid(),
    categoryName: "Kunai",
    description: "",
  },
];
